export const replacePlaceholder = (
  value: string,
  variables: Record<string, string | undefined>,
): string => {
  const keys = Object.keys(variables);
  return keys.reduce((acc, key) => {
    const re = new RegExp(`{+\\s*${key}\\s*}+`, "g");
    return acc.replace(re, variables[key] ?? "");
  }, value);
};
